import React from 'react';
import { useSelector } from 'react-redux';
// import FieldRenderingEngine from "../FieldRenderingEngine";
import FieldDisplayEngine from "../FieldDisplayEngine";
import { RenderEngineKey } from '../../containers/WorkkardDetail/constants';
import {ListingViewConstants} from '../../common/constants';
import UserImage from '../UserImage/index';
import { useModules } from '../../utils/modules';

const displayFieldsFor = (listingData, type) =>
    type === ListingViewConstants.Activity ? listingData?.workkardInfo : listingData?.customFields;

const renderCustomFields = (props, listingData, userTimezone, tzData, type) => {
    const fields = displayFieldsFor(listingData, type);
    if (fields) {
        return (
            <FieldDisplayEngine userTimezone={userTimezone} tzData={tzData} data={fields} renderLocation={'card'} renderType={type} {...props} />
        );
    } else
        return "";
}

const Card = (props) => {
    const { listingData, history,type,userTimezone, tzData } = props;
    let route = `/getclmdetail?cId=${listingData.workkardId}`;
    let status, cardTitle, statusColor;
    if(type === ListingViewConstants.Activity){
        route = `${route}&actId=${listingData.activityId}`
        status =  listingData.resolutionForDisplay;
        if((listingData.resolutionForDisplay === 'IN PROGRESS'|| listingData.resolutionForDisplay === 'InProgress') && listingData.progress){
            status = `IN PROGRESS (${listingData.progress}% DONE)`
        }
        cardTitle = listingData.activityName;
        statusColor = listingData.statusColor;
    } else if(type === ListingViewConstants.Workkard){
        status = listingData.workkardNumber;
        cardTitle = listingData.workkardTitle;
        statusColor = `wkNumber`
    }

    const { isModuleEnabled } = useModules();

    const ownerId = listingData.sponsorId || listingData.activityOwnerId;
    const cachedOwnerUser = useSelector((state) =>
        ownerId ? state.userList?.[ownerId] : null);

    const ownerDisplayName = listingData.sponsorName || listingData.activityOwnerName ||
        (ownerId
            ? `${cachedOwnerUser?.first_name || cachedOwnerUser?.firstName || ''} ${cachedOwnerUser?.last_name || cachedOwnerUser?.lastName || ''}`.trim()
            : '');

    return (
        <div className={`card cardView ${listingData.colorCode ? listingData.colorCode : ''}`} onClick={() => { window.location = route}} >
            <ul className="colFlex">
                <li data-test={statusColor}>
                    <span className={statusColor} title={type === ListingViewConstants.Workkard ? `Workkard: ${status}` : ''}>{status}</span>
                    {
                         props.globalSearch != undefined ?
                         <div className="rowFlex userGroup alignMiddle alignRight">
                             <div className="userPic userPicIcon">
                               <UserImage profileUrl={listingData.sponsorImage || listingData.activityOwnerImage} profileName={ownerDisplayName}/>
                            </div>
                            <div className="userInfo">
                                <a href="javascript:void(0)">{ownerDisplayName}</a>
                            </div>
                         </div>
                         :
                         null
                    }
                </li>
                {cardTitle && <li data-test={`cardTitle`}><span className={`title`} title={cardTitle}>{cardTitle}</span></li>}
                {displayFieldsFor(listingData, type)?.length > 0 &&
                <>
                    {listingData && listingData.workkardTemplateId > 0 && <li data-test="customFields CustomerName">{renderCustomFields({
                        includeFields: [RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName]
                    }, listingData, userTimezone, tzData, type)}</li>}
                    <li data-test="customFields PropertyLocation">{renderCustomFields({
                        includeFields: [RenderEngineKey.PropertyLocation]
                    }, listingData, userTimezone, tzData, type)}</li>
                </>
                }
                    {
                        isModuleEnabled("workkards.listing.carrier") && (listingData.carrierName && listingData.carrierName.trim().length) &&
                        <li className="carrier" data-test="carrierName">
                            <label>Carrier :</label> {listingData.carrierName}
                        </li>
                    }

                    {renderCustomFields({
                        excludeFields:[RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName, RenderEngineKey.PropertyLocation],
                        includeFields:[RenderEngineKey.LossType, RenderEngineKey.LossDate, RenderEngineKey.ReportedDate, RenderEngineKey.ClaimType],
                        showLabel:true
                    }, listingData, userTimezone, tzData, type)}
                    {
                        listingData && listingData.skillSet &&
                        <li data-test="skillSet">
                            <label>SkillSet : </label>&nbsp;
                            {listingData.skillSet}
                        </li>
                    }
                    {type === ListingViewConstants.Activity && listingData.dueOn && (
                        <li data-test="dueOn">
                            <label>Due On : </label>&nbsp;
                            <span className="red">{listingData.dueOn}</span>
                        </li>
                    )}
                    {type === ListingViewConstants.Activity && listingData.workkardNumber && (
                        <li data-test="workkardNumber">
                            <label>Workkard Number : </label>&nbsp;
                            <span>{listingData.workkardNumber}</span>
                        </li>
                    )}
                    {type === ListingViewConstants.Workkard && listingData.createdDate && (
                        <li data-test="createdDate">
                            <label>Created Date : </label>&nbsp;
                            <span>{listingData.createdDateString}</span>
                        </li>
                    )}
                    {listingData && listingData.workkardStatus && listingData.workkardStatus.toLowerCase() === "close" && 
                        <li data-test="closedDate"> 
                            <label>Closed Date : </label>&nbsp;
                            {listingData.closedDate}
                        </li>
                    }
            </ul>
            
        </div>
    )
}

export default Card;